import breakpoint from "./breakpoint";

const burger = () => {
  const burger = document.querySelector(".burger");
  let isOpen = false;

  const openMenu = () => {
    const alert = document.querySelector(".alert");

    if (alert && window.scrollY < alert.offsetHeight) {
      window.scrollTo({ top: alert.offsetHeight });
    }

    document.body.classList.add("burger-open");
    isOpen = true;
  };

  const closeMenu = () => {
    document.body.classList.remove("burger-open");
    isOpen = false;
  };

  const reset = () => {
    if (isOpen) {
      closeMenu();
    }
  };

  burger.addEventListener("click", () => {
    if (!isOpen) {
      openMenu();
    } else {
      closeMenu();
    }
  });

  breakpoint(() => {
    reset();
  });
};

export default burger;
